// src/services/AuthService.js
const API_URL = process.env.REACT_APP_API_URL; // Get the API URL from env variables

const AuthService = {
  login: async (identifier, password) => {
    try {
      const response = await fetch(`${API_URL}/auth/login`, { // Use template literal
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ identifier, password }),
      });

      if (!response.ok) {
        const errorData = await response.json(); // Try to get error details from the server
        throw new Error(errorData.message || 'Login failed'); // Throw an error with details
      }

      const data = await response.json();
      return data; // Return the token (and user data if available)

    } catch (error) {
      console.error("Login error:", error);
      throw error; // Re-throw the error to be handled by the component
    }
  },

  register: async (userData) => {
    try {
      const response = await fetch(`${API_URL}/auth/register`, { // Use API_URL
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(userData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Registration failed');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Registration error:", error);
      throw error;
    }
  },

  forgotPassword: async (email) => {
    try {
      const response = await fetch(`${API_URL}/auth/forgot-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Forgot password request failed');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Forgot password error:", error);
      throw error;
    }
  },

  resetPassword: async (userData) => {
    try {
      const response = await fetch(`${API_URL}/auth/reset-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(userData),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Reset password failed');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Reset password error:", error);
      throw error;
    }
  },

  ensureParsed: (data) => {
    if (typeof data === 'string') {
      try {
        return JSON.parse(data);
      } catch (error) {
        console.error("Error parsing JSON:", error);
        return data; // Or handle the error as needed
      }
    }
    return data; // Already parsed (an object)
  }
};

export default AuthService;